import { QueryClientProvider } from '@tanstack/react-query'
import { queryClient } from './client'

function QueryProvider({ children }) {
  return <QueryClientProvider client={queryClient}>{children(queryClient)}</QueryClientProvider>
}

export default QueryProvider
